import { Region } from '@lemon8/web-app-shared/i18n';

export default function switchLang(config: { region: Region }): void {
  const { region } = config;
  const href = new URL(location.href);

  href.searchParams.set('region', region);
  location.href = href.toString();
}
